import { ButtonVariants } from '@/components/atoms/Button/Button';
import ButtonLink from '@/components/atoms/ButtonLink/ButtonLink';
import { SocialsProfileIcon } from '@/components/molecules/SocialsProfileIcon/SocialsProfileIcon';
import { FC, useEffect, useRef, useState } from 'react';

import { SwiperCarousel } from '@/components/molecules/SwiperCarousel/SwiperCarousel';

const youtubeLinks = [
  'https://www.youtube.com/embed/MXcYGkDdQ90',
  'https://www.youtube.com/embed/5ismagyq0-w',
  'https://www.youtube.com/embed/fIDWSlR2vsI',
  'https://www.youtube.com/embed/saMD0GHn2sY',
];

const slides = youtubeLinks.map((link, index) => {
  return (
    <div
      key={`youtube-short-${index}`}
      className="aspect-[0.57] w-[255px] overflow-hidden rounded-small"
    >
      <iframe
        width="100%"
        height="100%"
        src={link}
        title="YouTube video player"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
});

export const SocialMediaCard: FC = () => {
  const slideWidth = 255;
  const spaceBetween = 12;

  const carouselWrapperRef = useRef<HTMLDivElement>(null);
  const [page, setPage] = useState(0);

  const [slidePerView, setSlidesPerView] = useState(4);
  useEffect(() => {
    const handleResize = () => {
      const wrapperWidth = carouselWrapperRef.current?.offsetWidth || 0;
      const slidesPerView = wrapperWidth / (slideWidth + spaceBetween);

      setSlidesPerView(slidesPerView);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [carouselWrapperRef]);

  const showCarousel = slides.length > slidePerView;

  return (
    <div className="flex flex-col gap-m py-3xl">
      <div className="flex justify-between">
        <div className="flex">
          <SocialsProfileIcon />
        </div>
        <div className="flex">
          <ButtonLink
            href={`${process.env.NEXT_PUBLIC_YOUTUBE_LINK}`}
            size="small"
            variant={ButtonVariants.Secondary}
            aria-label={'Subscribe to EV.com on Youtube'}
          >
            Subscribe
          </ButtonLink>
        </div>
      </div>
      <div className="flex" ref={carouselWrapperRef}>
        {showCarousel ? (
          <SwiperCarousel
            slidesPerView={slidePerView}
            spaceBetween={spaceBetween}
            slides={slides}
            updateCurrentIndex={setPage}
            selectedIndex={page}
            navigation={true}
            navigationVariant="between"
          />
        ) : (
          <div
            className="flex"
            style={{
              columnGap: `${spaceBetween}px`,
            }}
          >
            {slides}
          </div>
        )}
      </div>
    </div>
  );
};
